import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { ruRU } from '@mui/x-date-pickers/locales'
import './index.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import 'dayjs/locale/ru'
import { setupApp } from './setupApp'
import { UserStore } from 'store/UserStore'
import { AuthStore } from './store/AuthStore'

import createRouter from './router'

import 'react-toastify/dist/ReactToastify.css'
import './App.css'

const ruLocale = ruRU.components.MuiLocalizationProvider.defaultProps.localeText

let api, axios
;(async () => {
  const { api: _api, axios: _axios } = await setupApp()

  api = _api
  axios = _axios

  await AuthStore.checkAuth(api)
  await UserStore.getUserData()

  const router = createRouter()

  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    <React.StrictMode>
      <LocalizationProvider
        dateAdapter={AdapterDayjs}
        adapterLocale="ru"
        localeText={ruLocale}
      >
        <RouterProvider router={router}></RouterProvider>
      </LocalizationProvider>
    </React.StrictMode>
  )
})()

export { api, axios }
